enum RouterPathEnum {
    Home = "/",
    Surveys = "/surveys/",
    SurveyDetail = '/surveys/:id',
}

export default RouterPathEnum;